import React, { useState } from 'react';
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,

  Avatar,
  Menu,
  MenuItem,
  Box,

  Divider,
  Tooltip,
  Chip,
} from '@mui/material';
import {
  Menu as MenuIcon,


  Help as HelpIcon,

  Logout as LogoutIcon,
  Person as PersonIcon,

} from '@mui/icons-material';

import { getLocalValue, LoacalVariables, toTitleCase } from '../../commonFunctions/CommonFunctions';

interface NavbarProps {
  onMenuClick: () => void;
  isSidebarCollapsed: boolean;
  colors: {
    contentBg: string;
    accent: string;
    sidebarBg: string;
  };
}

const Navbar: React.FC<NavbarProps> = ({ onMenuClick, isSidebarCollapsed, colors }) => {

  const userName = getLocalValue(LoacalVariables.UserName);
  const userRole = getLocalValue(LoacalVariables.UserType);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [notificationsAnchor, setNotificationsAnchor] = useState<null | HTMLElement>(null);
  const [darkMode, setDarkMode] = useState(false);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleNotificationsOpen = (event: React.MouseEvent<HTMLElement>) => {
    setNotificationsAnchor(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
    setNotificationsAnchor(null);
  };

  const handleLogout = () => {
    localStorage.clear();
    window.location.reload();
  }

  // const toggleDarkMode = () => {
  //   setDarkMode(!darkMode);
  // };

  // Mock data
  const user = {
    name: 'John Doe',
    role: 'Administrator',
    avatar: '/path-to-avatar.jpg', // Replace with actual avatar path
  };

  const notifications = [
    { id: 1, text: 'New user registered', time: '5 min ago', unread: true },
    { id: 2, text: 'System backup completed', time: '1 hour ago', unread: true },
    { id: 3, text: 'New message from Sarah', time: '2 hours ago', unread: false },
  ];

  const unreadCount = notifications.filter(n => n.unread).length;

  return (
    <>
      <AppBar
        position="sticky"
        sx={{
          backgroundColor: darkMode ? '#000080' : '#FFFFFF',
          color: darkMode ? '#FFFFFF' : '#000080',
          boxShadow: '0 2px 12px #0000)',
          borderBottom: `1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(0,0,0,0.08)'}`,
          transition: 'all 0.3s ease',
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between', padding: '0 16px !important' }}>
          {/* Left Section */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Tooltip title={isSidebarCollapsed ? "Expand Sidebar" : "Collapse Sidebar"}>
              <IconButton
                edge="start"
                onClick={onMenuClick}
                sx={{
                  color: 'inherit',
                  backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(46, 125, 50, 0.08)',
                  '&:hover': {
                    backgroundColor: darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(46, 125, 50, 0.12)',
                    transform: 'scale(1.05)',
                  },
                  transition: 'all 0.2s ease',
                }}
              >
                <MenuIcon />
              </IconButton>
            </Tooltip>

            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                background: colors.sidebarBg,
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
                display: { xs: 'none', sm: 'block' }
              }}
            >
              Dashboard
            </Typography>
          </Box>

          {/* Search Bar - Center */}
          {/* <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              alignItems: 'center',
              backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(46, 125, 50, 0.04)',
              borderRadius: '12px',
              padding: '4px 12px',
              minWidth: 300,
              border: `1px solid ${darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(46, 125, 50, 0.1)'}`,
              transition: 'all 0.2s ease',
              '&:focus-within': {
                borderColor: colors.accent,
                boxShadow: `0 0 0 2px ${colors.accent}20`,
              },
            }}
          >
            <SearchIcon sx={{ color: 'inherit', opacity: 0.7, fontSize: 20 }} />
            <InputBase
              placeholder="Search..."
              fullWidth
              sx={{
                ml: 1,
                flex: 1,
                color: 'inherit',
                '& .MuiInputBase-input': {
                  padding: '8px',
                  '&::placeholder': {
                    opacity: 0.6,
                    color: 'inherit',
                  },
                },
              }}
            />
          </Box> */}

          {/* Right Section */}
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            {/* Dark Mode Toggle */}
            {/* <Tooltip title={darkMode ? "Light Mode" : "Dark Mode"}>
              <IconButton
                onClick={toggleDarkMode}
                sx={{
                  color: 'inherit',
                  '&:hover': {
                    backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(46, 125, 50, 0.08)',
                  },
                }}
              >
                {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
            </Tooltip> */}

            {/* Help */}
            <Tooltip title="Help & Support">
              <IconButton
                LinkComponent={'a'}
                href="https://willsoartechnologies.com/quote.html"
                target="_blank"
                rel="noopener"
                sx={{
                  color: 'inherit',
                  '&:hover': {
                    backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(46, 125, 50, 0.08)',
                  },
                }}
              >
                <HelpIcon />
              </IconButton>
            </Tooltip>

            {/* Notifications */}
            {/* <Tooltip title="Notifications">
              <IconButton
                onClick={handleNotificationsOpen}
                sx={{
                  color: 'inherit',
                  position: 'relative',
                  '&:hover': {
                    backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(46, 125, 50, 0.08)',
                  },
                }}
              >
                <Badge 
                  badgeContent={unreadCount} 
                  color="error"
                  sx={{
                    '& .MuiBadge-badge': {
                      fontSize: '0.7rem',
                      height: '18px',
                      minWidth: '18px',
                    },
                  }}
                >
                  <NotificationsIcon />
                </Badge>
              </IconButton>
            </Tooltip> */}

            {/* Messages */}
            {/* <Tooltip title="Messages">
              <IconButton
                sx={{
                  color: 'inherit',
                  '&:hover': {
                    backgroundColor: darkMode ? 'rgba(255,255,255,0.1)' : 'rgba(46, 125, 50, 0.08)',
                  },
                }}
              >
                <Badge badgeContent={3} color="error">
                  <EmailIcon />
                </Badge>
              </IconButton>
            </Tooltip> */}

            {/* User Profile */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, ml: 1 }}>
              <Tooltip title="Account settings">
                <IconButton
                  onClick={handleProfileMenuOpen}
                  sx={{
                    padding: '4px',
                    border: `2px solid ${darkMode ? 'rgba(255,255,255,0.2)' : 'rgba(46, 125, 50, 0.2)'}`,
                    '&:hover': {
                      borderColor: colors.accent,
                      transform: 'scale(1.05)',
                    },
                    transition: 'all 0.2s ease',
                  }}
                >
                  <Avatar
                    src={user.avatar}
                    sx={{
                      width: 36,
                      height: 36,
                      backgroundColor: colors.accent,
                    }}
                  >
                    <PersonIcon />
                  </Avatar>
                </IconButton>
              </Tooltip>

              <Box sx={{ display: { xs: 'none', md: 'block' } }}>
                <Typography variant="subtitle2" sx={{ fontWeight: 600, lineHeight: 1.2 }}>
                  {toTitleCase(userName)}
                </Typography>
                <Chip
                  label={toTitleCase(userRole)}
                  size="small"
                  sx={{
                    height: 20,
                    fontSize: '0.7rem',
                    backgroundColor: colors.accent,
                    color: '#ffff',
                    fontWeight: 500,
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Toolbar>
      </AppBar>

      {/* Notifications Menu */}
      <Menu
        anchorEl={notificationsAnchor}
        open={Boolean(notificationsAnchor)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: 360,
            maxHeight: 400,
            mt: 1.5,
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          },
        }}
      >
        <Box sx={{ p: 2, pb: 1 }}>
          <Typography variant="h6" sx={{ fontWeight: 600 }}>
            Notifications
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {unreadCount} unread messages
          </Typography>
        </Box>
        <Divider />
        {notifications.map((notification) => (
          <MenuItem key={notification.id} onClick={handleMenuClose} sx={{ py: 1.5 }}>
            <Box sx={{ width: '100%' }}>
              <Typography variant="body2" sx={{ fontWeight: notification.unread ? 600 : 400 }}>
                {notification.text}
              </Typography>
              <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                {notification.time}
              </Typography>
            </Box>
            {notification.unread && (
              <Box
                sx={{
                  width: 8,
                  height: 8,
                  borderRadius: '50%',
                  backgroundColor: colors.accent,
                  ml: 1,
                }}
              />
            )}
          </MenuItem>
        ))}
      </Menu>

      {/* Profile Menu */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleMenuClose}
        PaperProps={{
          sx: {
            width: 220,
            mt: 1.5,
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.12)',
          },
        }}
      >
        <Box sx={{ p: 2, textAlign: 'center' }}>
          <Avatar
            src={user.avatar}
            sx={{
              width: 60,
              height: 60,
              mx: 'auto',
              mb: 1,
              backgroundColor: colors.accent,
            }}
          />
          <Typography variant="subtitle1" sx={{ fontWeight: 600 }} >
            {toTitleCase(userName)}
          </Typography>
          <Typography variant="body2" sx={{ color: "#ffff" }}>
            {toTitleCase(userRole)}
          </Typography>
        </Box>
        <Divider />
        {/* <MenuItem onClick={handleMenuClose}>
          <PersonIcon sx={{ mr: 2, fontSize: 20 }} />
          Profile
        </MenuItem>
        <MenuItem onClick={handleMenuClose}>
          <SettingsIcon sx={{ mr: 2, fontSize: 20 }} />
          Settings
        </MenuItem> */}
        <MenuItem LinkComponent={'a'} href="https://willsoartechnologies.com/quote.html" target="_blank" rel="noopener" onClick={handleMenuClose}>
          <HelpIcon sx={{ mr: 2, fontSize: 20 }} />
          Help & Support
        </MenuItem>
        {/* <MenuItem onClick={toggleDarkMode}>
          {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
          <Typography sx={{ ml: 2 }}>
            {darkMode ? 'Light Mode' : 'Dark Mode'}
          </Typography>
        </MenuItem> */}
        <Divider />
        <MenuItem onClick={handleLogout} sx={{ color: 'error.main' }}>
          <LogoutIcon sx={{ mr: 2, fontSize: 20 }} />
          Logout
        </MenuItem>
      </Menu>
    </>
  );
};

export default Navbar;